const ENImportLogs = {
	"Mensagens de importação":"Import messages",
	"Logs de importação":"Values Import logs",
	"Mensagens dos logs de importação":"Import log messages",
	"Processados":"Processed",
	"Importados":"Imported",
	"Data e hora":"Date and hour",
	// Errors from back end
	"Extensão de arquivo não suportada.":"File extension not suported.",
	"Ocorreu problemas ao processar o arquivo":"Problems on file procesing"
};

export default ENImportLogs;
